import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Streetlights } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  streetlights: Streetlights;
}

const StreetlightDetails: React.FC<Props> = ({ streetlights }) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '35%' }} />
          <col style={{ width: '35%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('Installed wattage (watts)')}</th>
            <th>{t('Avg. annual daily operating hours (hrs/day)')}</th>
            <th>{t('Subtotal annual electricity consumption (MWh)')}</th>
          </tr>
        </thead>
        <tbody>
          {streetlights.numberOfBulbs && streetlights.wattage && streetlights.hoursDay && (
            <tr>
              <td>
                <NumberFormatterSinSeparador
                  value={streetlights.numberOfBulbs * streetlights.wattage}
                />
              </td>
              <td>
                <NumberFormatterSinSeparador value={streetlights.hoursDay} />
              </td>
              <td>
                <NumberFormatterSinSeparador
                  value={
                    (streetlights.numberOfBulbs *
                      streetlights.wattage *
                      streetlights.hoursDay *
                      365) /
                    1000000
                  }
                />
              </td>
            </tr>
          )}
          <tfoot>
            <tr>
              {/* espaciador intencional, sin contenido */}
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td colSpan={3} />
            </tr>
          </tfoot>
        </tbody>
      </Table>
    </div>
  );
};

export default StreetlightDetails;
